<template>
  <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true" small="small">
    <el-row>
      <el-col :span="6">
        <el-form-item label="治疗总费用" prop="operationAmount">
          <el-input :value="formData.operationAmount ? parseFloat(formData.operationAmount || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="医保报销" prop="reimburAmount">
          <el-input :value="formData.reimburAmount ? parseFloat(formData.reimburAmount || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="其他资助" prop="otherHelp">
          <el-input :value="formData.otherHelp ? parseFloat(formData.otherHelp || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="医院减免" prop="hospitalReduction">
          <el-input :value="formData.hospitalReduction ? parseFloat(formData.hospitalReduction || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="救助费用" prop="helpAmount">
          <el-input :value="formData.helpAmount ? parseFloat(formData.helpAmount || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="自付费用" prop="selfPayAmount">
          <el-input :value="formData.selfPayAmount ? parseFloat(formData.selfPayAmount || 0).toFixed(2) : '-'" disabled size="small" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="formData.initialProject == 'AY1001'" :span="6">
        <el-form-item v-if="formData.initialProject == 'AY1001'" label="手术方式" prop="operationMode">
          <DictionarySelect v-model="formData.operationMode" :lazy="true" tableCode="OPERATION_MODE" :disabled="localReadOnly"></DictionarySelect>
        </el-form-item>
      </el-col>
      <el-col v-else :span="6">
        <el-form-item label="是否手术" prop="isOperation">
          <el-select v-model="formData.isOperation" size="small" disabled clearable>
            <el-option :value="1" label="是"></el-option>
            <el-option :value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手术时间" prop="operationTime">
          <el-date-picker
            v-if="formData.initialProject == 'AY1001' || (formData.initialProject == 'AY1003' && formData.isOperation == 1)"
            v-model="formData.operationTime"
            align="right"
            type="date"
            size="small"
            placeholder="选择时间"
            :disabled="localReadOnly || (formData.initialProject == 'AY1003' && formData.isOperation == 0)"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @input="calcAge">
          </el-date-picker>
          <el-input type="text" v-else value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手术年龄" prop="operationAge">
          <el-input type="text" v-if="formData.operationAge" v-model="formData.operationAge" :disabled="true" size="small" />
          <el-input type="text" v-else value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="住院号" prop="inHospitalNo">
          <el-input v-if="formData.inHospitalNo" type="text" v-model="formData.inHospitalNo" :disabled="localReadOnly" size="small" />
          <el-input type="text" v-else value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="入院时间" prop="inHospitalTime">
          <el-date-picker v-model="formData.inHospitalTime" align="right" type="date" size="small" placeholder="选择时间" value-format="timestamp" :disabled="localReadOnly"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="出院时间" prop="outHospitalTime">
          <el-date-picker v-model="formData.outHospitalTime" align="right" type="date" size="small" placeholder="选择时间" value-format="timestamp" :disabled="localReadOnly"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="治愈状态" prop="healState">
          <DictionarySelect v-model="formData.healState" :lazy="true" tableCode="HEAL_STATE" :excludeKeys="this.hospitalName == '武汉大学中南医院' ?[]:['7']" :disabled="localReadOnly"></DictionarySelect>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="术前病种" prop="beforeDiseasesList">
          <DiseaseCascader
            v-model="formData.beforeDiseasesIdList"
            :hospitalId="formData.hospitalId"
            :all="true"
            :multiple="true"
            :disabled="true">
          </DiseaseCascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="术后病种" prop="afterDiseasesIdList">
          <DiseaseCascader
            v-model="formData.afterDiseasesIdList"
            :hospitalId="formData.hospitalId"
            :multiple="true"
            :all="true"
            :disabled="localReadOnly">
          </DiseaseCascader>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="formData.remark" :rows="3" size="small" :disabled="localReadOnly" style="width: 100%;"/>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-row>
      <el-col :span="12">
        <el-form-item label="发票附件" prop="attachList">
          <FileUpload v-model="formData.attachList" :disabled="localReadOnly"></FileUpload>
        </el-form-item>
      </el-col>
    </el-row> -->
  </el-form>
</template>

<script>
import { getOutlayDataById, saveCureOutlay, submitCureOutlay } from "@/util/api.js";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import {getAccountSystemInfo} from "../../../util/api";

export default {
  components: {
    DictionarySelect,
    DiseaseCascader,
    FileUpload,
    MoneyInput
  },
  props: {
    outlayId: String,
    readOnly: false,
  },
  data () {
    let _this = this
    return {
      loading: false,
      localReadOnly: true,
      pickerOptions: {
        disabledDate (time) {
          let birthday = new Date(_this.formData.birthday);
          let startDate = birthday.setDate(birthday.getDate() - 1);
          return time.getTime() > Date.now() || time.getTime() < startDate;
        }
      },
      formData: {},
      formRules: {
        operationAmount: [{ required: true, message: '请输入治疗总费用', trigger: 'blur' }],
        reimburAmount: [{ required: true, message: '请输入医保报销', trigger: 'blur' }],
        otherHelp: [{ required: true, message: '请输入其他资助', trigger: 'blur' }],
        hospitalReduction: [{ required: true, message: '请输入医院减免', trigger: 'blur' }],
        operationMode: [{ required: true, message: '请选择手术方式', trigger: 'change' }],
        operationTime: [{ required: true, message: '请选择手术时间', trigger: 'blur' }],
        inHospitalNo: [{ required: true, message: '请输入住院号', trigger: 'blur' }],
        inHospitalTime: [{ required: true, message: '请选择入院时间', trigger: 'blur' }],
        afterDiseasesIdList: [{ required: true, message: '请选择术后病种', trigger: 'blur' }],
        healState: [{ required: true, message: '请选择治愈状态', trigger: 'change' }],
      },
      hospitalName:''
    }
  },
  watch: {
    outlayId: {
      immediate: true,
      handler () {
        this.loadData()
      }
    }
  },
  created() {
    this.getHospitalInfo();
  },
  methods: {
    loadData () {
      if (this.outlayId) {
        this.loading = true;
        getOutlayDataById(this.outlayId).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.formData = res.responseData;
            if (this.formData.beforeDiseasesList && this.formData.beforeDiseasesList.length > 0) {
              this.formData.beforeDiseasesIdList = this.formData.beforeDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            }
            if (this.formData.afterDiseasesList && this.formData.afterDiseasesList.length > 0) {
              this.formData.afterDiseasesIdList = this.formData.afterDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            } else {
              this.formData.afterDiseasesIdList = this.formData.beforeDiseasesIdList;
            }
            this.formData.otherHelp = this.formData.otherHelp || 0;
            this.formData.hospitalReduction = this.formData.hospitalReduction || 0;
            this.formData.helpAmount = this.formData.helpAmount || 0;
            this.formData.selfPayAmount = this.formData.selfPayAmount || 0;
            this.localReadOnly = this.readOnly || [0, 2].indexOf(this.formData.outlayStatus) < 0;
            this.calcAge();
            this.$emit('onload', this.formData);
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.localReadOnly = true;
      }
    },
    calcOutlay () {
      if (this.formData.operationAmount) {
        this.formData.helpAmount = parseFloat(this.formData.operationAmount || 0) - parseFloat(this.formData.reimburAmount || 0) - parseFloat(this.formData.otherHelp || 0) - parseFloat(this.formData.hospitalReduction || 0);
        let quota = parseFloat(this.formData.helpQuota || 0) + parseFloat(this.formData.specialQuota || 0);
        if (parseFloat(this.formData.helpAmount || 0) < 0) {
          this.formData.helpAmount = 0;
        } else if (parseFloat(this.formData.helpAmount || 0) > quota) {
          this.formData.selfPayAmount = (parseFloat(this.formData.helpAmount || 0) - quota).toFixed(2);
          this.formData.helpAmount = quota;
        } else {
          this.formData.selfPayAmount = 0;
        }
        this.formData.helpAmount = this.formData.helpAmount.toFixed(2);
        this.formData.selfPayAmount = this.formData.selfPayAmount.toFixed(2);
      }
    },
    calcAge () {
      if (this.formData.isOperation == 1 && this.formData.operationTime && this.formData.birthday) {
        this.formData.operationTime = new Date(this.formData.operationTime);

        let endDate = this.formData.operationTime;
        let startDate = new Date(this.formData.birthday);
        let year = endDate.getFullYear() - startDate.getFullYear();
        let month = endDate.getMonth() - startDate.getMonth();
        let day = endDate.getDate() - startDate.getDate();

        if (month <= 0) {
          year--;
          month = endDate.getMonth() + 1 + (12 - (startDate.getMonth() + 1));
        }
        if (day < 0) {
          month--;
          let monthDayList = [1, 3, 5, 7, 8, 10, 12, 4, 6, 9, 11, 2];
          let monthDays = 0;
          let index = monthDayList.findIndex(d => {
            return d === startDate.getMonth() + 1
          });
          if (index <= 6) {
            monthDays = 31;
          } else if (index > 6 && index <= 10) {
            monthDays = 30;
          } else {
            monthDays = year % 4 == 0 ? 29 : 28;
          }
          day = endDate.getDate() + (monthDays - startDate.getDate());
        } else if (day >= 0 && month == 12) {
          year += 1;
          month = 0;
        }

        this.formData.operationAge = (year + '岁') + (month + '月') + (day + '天')
      } else {
        this.formData.operationAge = null;
      }
    },
    saveData () {
      let valid = this.validateParams();
      if (valid) {
        this.loading = true;
        let params = this.makeParams();
        saveCureOutlay(params).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.$message.success('暂存成功！');
            this.$emit('success', this.formData);
          } else {
            this.$message.error(res.msg)
          }
          this.$emit('complete');
        })
      } else {
        this.$emit('complete');
      }
    },
    submitData () {
      this.$refs.formData.validate((valid) => {
        let validParams = this.validateParams();
        if (valid && validParams) {
          this.loading = true;
          let params = this.makeParams();
          submitCureOutlay(params).then(res => {
            this.loading = false;
            if (res.msgCode == 200) {
              this.$message.success('提交成功！');
              this.$emit('success', this.formData);
            } else {
              this.$message.error(res.msg)
            }
            this.$emit('complete');
          })
        } else {
          this.$emit('complete');
        }
      });
    },
    validateParams () {
      if (this.formData.operationTime && this.formData.inHospitalTime) {
        if (new Date(this.formData.operationTime) < new Date(this.formData.inHospitalTime)) {
          this.$message.error('手术时间不能小于入院时间！');
          return false;
        }
        if (this.formData.outHospitalTime) {
          if (new Date(this.formData.operationTime) >= new Date(this.formData.outHospitalTime)) {
            this.$message.error('手术时间不能大于等于出院时间！');
            return false;
          }
        }
      }
      if (this.formData.inHospitalTime && this.formData.outHospitalTime) {
        if (new Date(this.formData.inHospitalTime) >= new Date(this.formData.outHospitalTime)) {
          this.$message.error('入院时间不能小于等于出院时间！');
          return false;
        }
      }
      return true;
    },
    makeParams () {
      if (this.formData.afterDiseasesIdList && this.formData.afterDiseasesIdList.length > 0) {
        this.formData.afterDiseases = this.formData.afterDiseasesIdList.join(',');
      } else {
        this.formData.afterDiseases = null;
      }
      let params = {
        ...this.formData
      }
      delete params.helpQuota;
      delete params.specialQuota;
      return params;
    },
    getHospitalInfo(){
      getAccountSystemInfo().then((res) => {
        if(res.msgCode==200){
          this.hospitalName=res.responseData.name;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/outlay/view/CureOutlayTxCxForm.vue